import { defineComponentStyle } from "../../core"

export const textStyle = defineComponentStyle({})

export type TextStyle = typeof textStyle
